import { z } from "zod";
// Chi e che cosa si può chiamare, come lo legge la scheda del Lead (piano M4, Task 8, D9; questioni 163 e 164). La regola è
// `callability` del dominio, che i contratti non importano: l'elenco dei motivi qui sotto lo ripete, nello stesso ordine
// della regola, e un test del server lo confronta con i motivi che il dominio dà. Il file non importa altri contratti, così
// la scheda (`leads.ts`) e le chiamate (`calls.ts`) lo leggono senza importarsi a vicenda.
/** I motivi per cui «Chiama» è spento, nell'ordine in cui la regola li dice: il primo che vale è quello che si mostra. */
export const NOT_CALLABLE_REASONS = [
    "status_blocks",
    "phone_wrong",
    "no_phone",
    "telephony_off",
    "no_caller_number",
    "in_call",
    "reserved",
    "no_feature",
    "not_editable",
    "commercial_view",
    "platform_context",
];
export const notCallableReasonSchema = z.enum(NOT_CALLABLE_REASONS);
/** Un telefono attivo del Lead: si chiama, oppure il motivo (con il nome del collega in chiamata o che ha riservato il Lead). */
export const phoneCallabilitySchema = z.object({
    phoneId: z.string(),
    callable: z.boolean(),
    reason: notCallableReasonSchema.nullable(),
    byDisplayName: z.string().nullable(),
});
/**
 * «Chiama» nella scheda: acceso se almeno un telefono si chiama; altrimenti il motivo del primo telefono nell'ordine della
 * scheda o, per un Lead senza telefoni, quello del Lead. `activeCall` è la chiamata della telefonia ancora aperta sul Lead
 * (questione 163), con il nome di chi è al telefono e se è chi guarda.
 */
export const leadCallingSchema = z.object({
    callable: z.boolean(),
    reason: notCallableReasonSchema.nullable(),
    byDisplayName: z.string().nullable(),
    phones: z.array(phoneCallabilitySchema),
    activeCall: z.object({ byDisplayName: z.string(), mine: z.boolean() }).nullable(),
});
/** Una scheda di prima del Task 8, senza `calling`: nessun telefono si chiama. */
export const NO_CALLING = { callable: false, reason: null, byDisplayName: null, phones: [], activeCall: null };
//# sourceMappingURL=callability.js.map